import CustomFilterSelect from "./CustomFilterSelect";
const FilterLoanAttention = (props: any) => {
  return (
    <CustomFilterSelect
      source="attention"
      label="Attention"
      choices={[
        { id: "transferFailedNumber", name: "Transfer Failed" },
        {
          id: "insufficientBalanceCheckNumber",
          name: "Insufficient Balance",
        },
        { id: "transferFatalErrorNumber", name: "Funding Source Removed" },
        {
          id: "delinquentPastMaturity",
          name: "Delinquent Past Maturity",
        },
        {
          id: "n/a",
          name: "N/A",
        },
      ]}
      before={props?.before != null && props.before !== "" ? props.before : ""}
    />
  );
};

export default FilterLoanAttention;
